function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#2B2B2B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.546 21.093C4.731 21.093 0 16.361 0 10.546S4.731 0 10.546 0c5.815 0 10.546 4.731 10.546 10.546.001 5.815-4.731 10.547-10.546 10.547zm0-20.093C5.283 1 1 5.283 1 10.546c0 5.264 4.283 9.546 9.546 9.546 5.264 0 9.546-4.282 9.546-9.546C20.093 5.283 15.811 1 10.546 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.782 25a.502.502 0 01-.354-.146l-6.343-6.343a.5.5 0 01.707-.707l6.343 6.343a.5.5 0 01-.353.853z"
}));
function SvgFeatureSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgFeatureSearch;